/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="walkinManagerSettings.base.section.ts" />

module Meevo.Plugins.WalkinManagerSettings {
    'use strict';

    import Employee = Meevo.Model.Employee;

    /**
     * WalkIn Employee Section of Walkin Manager Settings
     */
    export class WalkInEmployeeSection extends Meevo.Plugins.WalkinManagerSettings.BaseSection {
        public employee: Employee[] = [];
        public selectedEmployee: Employee[] = [];

        private _backup: Employee[];
        private employeeWalkInCriteria = {
            itemsPerPage: 5000,
            criteria: {
                showEmployeesOnly: true
            }
        };

        private get dataToSave() {
            return {
                employeeListBookableWalkIn: this.selectedEmployee === null ? [] : this.selectedEmployee.map((item) => item.id),
                selectAll: false
            };
        }

        public activate(): void {
            if (!this.isLoaded) {
                this.dataService.getListPaged('employee', this.employeeWalkInCriteria).then((res) => {
                    this.employee = res;
                    this.selectedEmployee = res.filter((item) => item.allowBookableWalkIn);
                });
            }

            super.activate();
        }

        takeBackup(): void {
            this._backup = angular.copy(this.selectedEmployee);
        }

        rollbackChanges(): void {
            this.selectedEmployee = angular.copy(this._backup);
        }

        public customSave(): ng.IPromise<any> {
            return this.dataService.customMethodData(`/api/Employee/BookableWalkIn`, 'PATCH', this.dataToSave)
                .then((res) => {
                    this.employee = res.data;
                    this.selectedEmployee = res.data.filter((item) => item.allowBookableWalkIn);
                });
        }
    }
}
